"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgWifi = function SvgWifi(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    id: 'wifi_svg__a',
    d: 'M12.004 20c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM3 9a.998.998 0 0 1-.607-1.795C5.104 5.138 8.517 4 12.004 4c3.486 0 6.898 1.137 9.606 3.202a1 1 0 1 1-1.213 1.59C18.036 6.991 15.055 6 12.004 6c-3.052 0-6.034.992-8.398 2.795A.989.989 0 0 1 3 9zm2.204 2.584a1 1 0 0 1 .188-1.402c1.861-1.422 4.21-2.205 6.61-2.205 2.398 0 4.745.782 6.606 2.203a1 1 0 1 1-1.214 1.59c-1.515-1.156-3.43-1.793-5.393-1.793-1.964 0-3.88.638-5.396 1.795a.998.998 0 0 1-1.401-.188zM15 14.977a.995.995 0 0 1-.595-.197 4.058 4.058 0 0 0-4.808 0 1 1 0 0 1-1.193-1.606c2.11-1.565 5.083-1.566 7.193 0A1 1 0 0 1 15 14.977z'
  })), react_1.default.createElement("use", {
    xlinkHref: '#wifi_svg__a'
  }));
};

exports.default = SvgWifi;